<div class="mb-3">
  <h1 mat-dialog-title>{{user.name}}</h1>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content>
  <h3>Brugerens rettigheder</h3>
  <mat-accordion fxLayout="column" fxFlexFill>
    @for (permissionArea of permissions | keyvalue; track permissionArea) {
      <mat-expansion-panel class="permission-panel mat-background-accent">
        <mat-expansion-panel-header color="warn">
          {{'permissions.' + permissionArea.key + '.title' | translate}}
        </mat-expansion-panel-header>
        @for (permissionTerm of getPermission(permissionArea.key) | keyvalue; track permissionTerm) {
          <mat-list>
            <mat-list-item>
              <div fxLayoutAlign="space-between center" fxFlex="100">
                <span>{{'permissions.' + permissionArea.key + '.' + permissionTerm.key | translate}}</span>
                @if (permissionTerm.value) {
                  <mat-icon>check_circle</mat-icon>
                }
                @if (!permissionTerm.value) {
                  <mat-icon>block</mat-icon>
                }
              </div>
            </mat-list-item>
            <mat-divider></mat-divider>
          </mat-list>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-stroked-button mat-dialog-close color="primary">Luk</button>
</div>
